import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../AbstractElements';
import AssetOwnerRegistrationContain from '../../Component/SiteOwner/Registration/AssetOwnerRegistration';

const AssetOwnerRegistrationPage = () => {
  return (
    <Fragment>
      <AssetOwnerRegistrationContain />
    </Fragment>
  );
};
export default AssetOwnerRegistrationPage;